var formField = 'fx_2d2fb1e5_1v3o0pe0';

export { formField };
//# sourceMappingURL=formField.vanilla.mjs.map
